var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 600,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("g", {
    stroke: "null"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#F39494",
    d: "m264.90054,329.24564l-0.45873,-1.74317l-0.27524,1.10095l0.73397,0.64222z",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#F0F0F0",
    d: "m264.90512,600.3081l-16.41329,-178.3535c-0.4679,-5.10564 1.34866,-10.15165 4.98179,-13.75267l83.42889,-83.48852c3.54138,-3.54138 8.45895,-5.35794 13.44073,-5.0139l241.01118,17.72984c7.11029,0.53212 13.18843,5.39006 15.22519,12.21593l41.06993,136.31107c0.81654,2.72485 0.94039,5.60566 0.37616,8.36261l-21.34003,105.98914",
    className: "st1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#B2B6BB",
    d: "m433.34551,600.44571l6.37632,0",
    className: "st2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#B2B6BB",
    d: "m332.24183,600.44571l6.51394,0",
    className: "st2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#DADDDF",
    d: "m412.47338,490.30509c-0.18349,-1.28444 -1.33031,-2.11015 -2.61475,-1.97253",
    className: "st3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#DADDDF",
    d: "m435.59328,600.35397l-6.37632,0",
    className: "st3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#DADDDF",
    d: "m409.03292,482.09385c4.67903,-0.59635 8.89933,2.56888 9.63329,7.2479",
    className: "st3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#DADDDF",
    d: "m334.62721,600.39984l-6.51394,0",
    className: "st3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#B2B6BB",
    d: "m377.01369,522.27844",
    className: "st2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#B2B6BB",
    d: "m368.84833,600.44571l6.37632,0",
    className: "st2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#B2B6BB",
    d: "m267.74465,600.44571l6.51394,0",
    className: "st2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#DADDDF",
    d: "m371.0961,600.35397l-6.37632,0",
    className: "st3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#DADDDF",
    d: "m270.13004,600.39984l-6.51394,0",
    className: "st3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#D6D9DB",
    d: "m626.79117,280.94156l0,18.8996l5.68823,1.60555l0,48.39582l7.89012,0l0,-38.25793l18.57849,3.94506",
    className: "st4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#D6D9DB",
    d: "m678.85681,291.44644l20.55102,0",
    className: "st4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#D6D9DB",
    d: "m658.94801,315.52967l0,34.31286l10.55075,0l0,-32.0651l-10.55075,-2.24777z",
    className: "st4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#D6D9DB",
    d: "m640.36952,311.5846l0,38.25793l18.57849,0l0,-34.31286l-18.57849,-3.94506z",
    className: "st4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#D6D9DB",
    d: "m583.85421,349.84253l18.71611,0l0,-56.83642l14.95454,4.2203",
    className: "st4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#D6D9DB",
    d: "m669.49876,291.44644l0,26.331l0.77984,0.18349l0,31.88161l8.57822,0l0,-58.39609l-9.35805,0z",
    className: "st4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#D6D9DB",
    d: "m699.40783,291.44644l-20.55102,0l0,58.39609l20.55102,0l0,-58.39609z",
    className: "st4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#D6D9DB",
    d: "m669.49876,317.77743l0,32.0651l0.77984,0l0,-31.88161l-0.77984,-0.18349z",
    className: "st4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#D6D9DB",
    d: "m617.52486,297.22641l0,52.61612l9.26631,0l0,-50.00137l-9.26631,-2.61475z",
    className: "st4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#D6D9DB",
    d: "m626.79117,299.88704l0,50.00137l5.68823,0l0,-48.39582l-5.68823,-1.60555z",
    className: "st4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#D6D9DB",
    d: "m602.57032,293.00611l0,56.83642l14.95454,0l0,-52.61612l-14.95454,-4.2203z",
    className: "st4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#D6D9DB",
    d: "m699.40783,291.44644l0,58.39609",
    className: "st4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    fill: "#FFFFFF",
    opacity: 0.2,
    d: "m745.87699,233.00447l-20.00055,0l0,0.04587",
    className: "st5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    fill: "#FFFFFF",
    opacity: 0.2,
    d: "m614.35963,349.84253l19.95467,0",
    className: "st5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    fill: "#FFFFFF",
    opacity: 0.2,
    d: "m695.00404,349.84253",
    className: "st5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FFFFFF",
    d: "m686.19646,354.42981l5.91759,0",
    className: "st6"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FFFFFF",
    d: "m692.11405,227.13275l-5.91759,0",
    className: "st6"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#F0F0F0",
    d: "m692.11405,233.05035l-5.91759,0l0,1.37618l5.91759,0l0,-1.37618z",
    className: "st1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    d: "m697.16006,599.84937l-181.38111,0c-4.12855,0 -7.4314,-3.34872 -7.4314,-7.4314l0,-307.62309c0,-4.12855 3.34872,-7.4314 7.4314,-7.4314l181.42698,0c4.12855,0 7.4314,3.34872 7.4314,7.4314l0,307.57722c-0.04587,4.12855 -3.34872,7.47727 -7.47727,7.47727z",
    className: "st7"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    fill: "#FFFFFF",
    opacity: 0.2,
    d: "m697.16006,599.84937l-181.38111,0c-4.12855,0 -7.4314,-3.34872 -7.4314,-7.4314l0,-307.62309c0,-4.12855 3.34872,-7.4314 7.4314,-7.4314l181.42698,0c4.12855,0 7.4314,3.34872 7.4314,7.4314l0,307.57722c-0.04587,4.12855 -3.34872,7.47727 -7.47727,7.47727z",
    className: "st5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    d: "m693.35262,599.84937l-181.42698,0c-4.12855,0 -7.4314,-3.34872 -7.4314,-7.4314l0,-307.62309c0,-4.12855 3.34872,-7.4314 7.4314,-7.4314l181.42698,0c4.12855,0 7.4314,3.34872 7.4314,7.4314l0,307.57722c0,4.12855 -3.30284,7.47727 -7.4314,7.47727z",
    className: "st7"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    fill: "#FFFFFF",
    opacity: 0.6,
    d: "m693.35262,599.84937l-181.42698,0c-4.12855,0 -7.4314,-3.34872 -7.4314,-7.4314l0,-307.62309c0,-4.12855 3.34872,-7.4314 7.4314,-7.4314l181.42698,0c4.12855,0 7.4314,3.34872 7.4314,7.4314l0,307.57722c0,4.12855 -3.30284,7.47727 -7.4314,7.47727z",
    className: "st8"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FFFFFF",
    d: "m681.70092,590.33993l-162.06865,0c-1.5138,0 -2.75237,-1.23857 -2.75237,-2.75237l0,-159.4539c0,-1.5138 1.23857,-2.75237 2.75237,-2.75237l162.06865,0c1.5138,0 2.79824,1.23857 2.79824,2.75237l0,159.40803c0,1.55968 -1.23857,2.79824 -2.79824,2.79824z",
    className: "st6"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    d: "m658.90214,393.19234l-113.99394,0c-0.87158,0 -1.60555,-0.73397 -1.60555,-1.60555l0,-4.08268c0,-0.87158 0.73397,-1.60555 1.60555,-1.60555l113.99394,0c0.87158,0 1.60555,0.73397 1.60555,1.60555l0,4.08268c0,0.87158 -0.68809,1.60555 -1.60555,1.60555z",
    className: "st7"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#F3F3F3",
    d: "m648.85599,408.42211l-93.85578,0c-1.10095,0 -1.97253,-0.87158 -1.97253,-1.97253l0,-0.13762c0,-1.10095 0.87158,-1.97253 1.97253,-1.97253l93.85578,0c1.10095,0 1.97253,0.87158 1.97253,1.97253l0,0.13762c0,1.10095 -0.87158,1.97253 -1.97253,1.97253z",
    className: "st9"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#868A91",
    d: "m661.56276,440.71658l-87.15835,0c-1.0092,0 -1.83491,-0.82571 -1.83491,-1.83491l0,-0.13762c0,-1.0092 0.82571,-1.83491 1.83491,-1.83491l87.15835,0c1.0092,0 1.83491,0.82571 1.83491,1.83491l0,0.13762c0,1.0092 -0.82571,1.83491 -1.83491,1.83491z",
    className: "st10"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#868A91",
    d: "m615.0936,454.8454l-40.64331,0c-1.05507,0 -1.88079,-0.87158 -1.88079,-1.88079c0,-1.05507 0.82571,-1.88079 1.88079,-1.88079l40.64331,0c1.05507,0 1.88079,0.87158 1.88079,1.88079s-0.82571,1.88079 -1.88079,1.88079z",
    className: "st10"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    d: "m602.66207,373.42116c21.56022,0 39.03776,-17.47754 39.03776,-39.03776s-17.47754,-39.03776 -39.03776,-39.03776s-39.03776,17.47754 -39.03776,39.03776s17.47754,39.03776 39.03776,39.03776z",
    className: "st7"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#21252B",
    d: "m618.21295,319.15362l0,9.67916l-5.36712,0.41286l0.77984,-6.78918l4.58728,-3.30284z",
    className: "st11"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#21252B",
    d: "m602.66207,373.42116c14.90866,0 27.8448,-8.34885 34.45048,-20.64277c-0.45873,-0.13762 -0.96333,-0.22936 -1.42206,-0.32111l-19.45007,-2.56888l-22.24831,-0.59635l-17.20231,2.88999c-2.66062,0.45873 -4.95426,1.88079 -6.51394,3.89919c6.92679,10.459 18.85373,17.33992 32.38621,17.33992z",
    className: "st11"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FFFFFF",
    d: "m616.19455,349.8884c0,0.09175 2.2019,0.22936 2.2019,0.32111c0,0.13762 0,0.27524 0,0.41286c0,4.12855 -6.00934,7.47727 -13.39486,7.47727c-7.38552,0 -13.39486,-3.34872 -13.39486,-7.47727c0,-0.32111 0.04587,-0.64222 0.09175,-0.91746c0.04587,-0.13762 2.15602,-0.27524 2.15602,-0.36698l22.34006,0.55047z",
    className: "st6"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#F39494",
    d: "m594.03798,325.48407c0,0 19.67944,-12.33979 20.45928,2.75237l-0.55047,3.66983l1.55968,18.71611c0.59635,7.20203 -21.6061,7.47727 -21.6061,-0.45873l1.23857,-9.90853c-0.22936,-1.0092 -0.36698,-2.15602 -0.36698,-3.48633c-0.18349,-5.91759 -0.73397,-11.28471 -0.73397,-11.28471z",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#21252B",
    d: "m592.34068,324.88772c3.66983,0 6.65156,-2.98173 6.65156,-6.65156s-2.98173,-6.65156 -6.65156,-6.65156s-6.65156,2.98173 -6.65156,6.65156c-0.04587,3.66983 2.93586,6.65156 6.65156,6.65156z",
    className: "st11"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#F39494",
    d: "m591.83608,314.84157c0,0 -6.97267,29.31273 8.07362,31.28526c13.02788,1.74317 14.44994,-18.57849 14.44994,-18.57849l-0.64222,-13.1655l-21.88133,0.45873z",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#21252B",
    d: "m611.92837,324.38312c0.09175,4.35792 0,8.4406 -0.82571,10.9636c-0.41286,1.28444 -1.23857,2.47713 -3.85332,1.05507c-9.72504,-5.45886 -16.46834,-0.41286 -16.46834,-0.41286s0.96333,8.02774 7.61489,9.77091s15.32152,-2.38539 15.27565,-11.4682c0,-1.10095 0.64222,-7.61489 -0.27524,-10.87186c-0.91746,-3.34872 -2.0184,-3.48633 -2.0184,-3.48633l0.55047,4.44966z",
    className: "st11"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#21252B",
    d: "m598.85462,302.41004c3.66983,0 6.88092,1.5138 8.66996,3.80744c0.91746,1.14682 2.38539,1.65142 3.80744,1.42206c0.22936,-0.04587 1.05507,0 1.28444,0.04587c11.74344,0.82571 10.09202,18.395 -0.55047,16.97294c-2.24777,-0.32111 -4.26617,-1.88079 -5.36712,-4.40379c-0.77984,-1.74317 -2.66062,-2.66062 -4.49554,-2.15602c-1.05507,0.27524 -2.15602,0.45873 -3.34872,0.45873c-5.64236,0 -10.18376,-3.62395 -10.18376,-8.07362c0,-4.44966 4.54141,-8.07362 10.18376,-8.07362z",
    className: "st11"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#966363",
    d: "m591.74434,317.18109c0.59635,0.45873 1.83491,1.0092 1.83491,1.0092c0.13762,0.04587 0.36698,0.04587 0.41286,-0.13762c0.04587,-0.18349 0.04587,-0.36698 -0.13762,-0.41286c0,0 -1.74317,-1.05507 -1.92666,-1.14682c-0.32111,-0.27524 -0.82571,-0.64222 -1.37618,-1.23857c-0.09175,-0.13762 -0.32111,-0.18349 -0.45873,-0.04587c-0.13762,0.09175 -0.18349,0.27524 -0.04587,0.41286c0.55047,0.68809 1.5138,1.42206 1.69729,1.55968z",
    className: "st12"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    opacity: 0.15,
    d: "m594.35909,348.23698l0.41286,-4.49554c1.60555,1.55968 4.26617,2.75237 8.39472,2.29364c0,0 2.79824,-0.18349 5.82585,-1.83491c0.22936,-0.13762 0.36698,-0.13762 0.45873,-0.04587c0.09175,0.13762 0.04587,0.27524 -0.04587,0.36698c-0.59635,0.5046 -2.84411,1.60555 -6.33045,2.11015c-4.90839,3.25697 -8.71583,1.60555 -8.71583,1.60555z",
    className: "st13"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#21252B",
    d: "m602.61619,327.68596c0.64222,0 1.19269,-0.55047 1.19269,-1.19269s-0.55047,-1.19269 -1.19269,-1.19269s-1.19269,0.55047 -1.19269,1.19269s0.55047,1.19269 1.19269,1.19269z",
    className: "st11"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FFFFFF",
    d: "m602.11159,326.35565c0.13762,0 0.22936,-0.09175 0.22936,-0.22936c0,-0.13762 -0.09175,-0.22936 -0.22936,-0.22936c-0.13762,0 -0.22936,0.09175 -0.22936,0.22936c0,0.13762 0.09175,0.22936 0.22936,0.22936z",
    className: "st6"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#21252B",
    d: "m593.07465,327.73183c0.64222,0 1.19269,-0.55047 1.19269,-1.19269s-0.55047,-1.19269 -1.19269,-1.19269c-0.64222,0 -1.19269,0.55047 -1.19269,1.19269s0.55047,1.19269 1.19269,1.19269z",
    className: "st11"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FFFFFF",
    d: "m592.57005,326.40152c0.13762,0 0.22936,-0.09175 0.22936,-0.22936c0,-0.13762 -0.09175,-0.22936 -0.22936,-0.22936c-0.13762,0 -0.22936,0.09175 -0.22936,0.22936c0,0.13762 0.09175,0.22936 0.22936,0.22936z",
    className: "st6"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#21252B",
    d: "m587.93689,325.16296l0,1.33031c0,2.61475 2.11015,4.7249 4.7249,4.7249s4.7249,-2.11015 4.7249,-4.7249l0,-1.33031c0,-0.41286 -0.09175,-0.77984 -0.32111,-1.05507l1.83491,0c-0.22936,0.27524 -0.36698,0.68809 -0.36698,1.05507l0,1.33031c0,2.61475 2.11015,4.7249 4.7249,4.7249c2.61475,0 4.7249,-2.11015 4.7249,-4.7249l0,-1.33031c0,-0.96333 -0.77984,-1.74317 -1.74317,-1.74317l-5.91759,0l-0.04587,0l-4.58728,0l-0.73397,0l-5.2295,0c-1.0092,0 -1.78904,0.77984 -1.78904,1.74317zm12.24804,-1.0092l5.96347,0c0.59635,0 1.05507,0.5046 1.05507,1.05507l0,1.33031c0,2.2019 -1.83491,3.99093 -4.03681,3.99093s-3.99093,-1.83491 -3.99093,-4.03681l0,-1.33031c0,-0.59635 0.45873,-1.0092 1.0092,-1.0092zm-11.60582,1.05507c0,-0.59635 0.45873,-1.05507 1.05507,-1.05507l5.27537,0l0.73397,0c0.59635,0 1.05507,0.45873 1.05507,1.05507l0,1.33031c0,2.2019 -1.83491,3.99093 -4.03681,3.99093s-3.99093,-1.83491 -3.99093,-4.03681l-0.09175,-1.28444z",
    className: "st11"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#F39494",
    d: "m613.71741,333.55768l-0.27524,-7.52314c0,0 1.19269,-3.11935 4.26617,-1.83491c3.57808,1.46793 0.91746,10.9636 -3.99093,9.35805z",
    className: "st0"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    opacity: 0.5,
    className: "st14"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    opacity: 0.5,
    d: "m614.68074,329.19976c0.22936,0 0.36698,-0.18349 0.36698,-0.41286c0,-1.19269 0.27524,-1.97253 0.77984,-2.33951c0.64222,-0.41286 1.46793,-0.04587 1.46793,-0.04587c0.18349,0.09175 0.41286,0 0.5046,-0.18349c0.09175,-0.18349 0,-0.41286 -0.18349,-0.5046c-0.04587,0 -1.23857,-0.5046 -2.2019,0.09175c-0.73397,0.5046 -1.14682,1.5138 -1.14682,2.98173c0.04587,0.22936 0.18349,0.41286 0.41286,0.41286z",
    className: "st15"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FFFFFF",
    d: "m602.52445,336.49354l-6.7433,-0.04587l0.22936,0.5046c1.23857,3.16522 5.7341,2.84411 6.51394,-0.45873z",
    className: "st6"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    opacity: 0.5,
    className: "st14"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    opacity: 0.5,
    d: "m597.06558,333.74117l0.68809,0c0.22936,0 0.41286,-0.18349 0.41286,-0.41286s-0.18349,-0.41286 -0.41286,-0.41286l-0.68809,0c-0.59635,0 -1.05507,-0.45873 -1.05507,-1.05507c0,-0.5046 0.36698,-0.91746 0.82571,-1.05507c0.22936,-0.04587 0.32111,-0.27524 0.27524,-0.45873c-0.04587,-0.22936 -0.27524,-0.32111 -0.45873,-0.27524c-0.87158,0.18349 -1.42206,0.91746 -1.42206,1.78904c-0.04587,1.05507 0.77984,1.88079 1.83491,1.88079z",
    className: "st15"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    d: "m628.58021,353.74172l-1.65142,2.0184l1.0092,0.82571l1.65142,-2.0184l-1.0092,-0.82571z",
    className: "st7"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    d: "m584.7258,351.81506l-1.65142,2.0184l1.0092,0.82571l1.65142,-2.0184l-1.0092,-0.82571z",
    className: "st7"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    d: "m603.02905,369.52197l-0.09175,2.61475l1.28444,0.04587l0.09175,-2.61475l-1.28444,-0.04587z",
    className: "st7"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    d: "m619.40564,365.02643l-0.27524,1.23857l2.56888,0.55047l0.27524,-1.23857l-2.56888,-0.55047z",
    className: "st7"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    d: "m578.62471,362.73279l-0.91746,0.91746l1.83491,1.88079l0.91746,-0.91746l-1.83491,-1.88079z",
    className: "st7"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    d: "m606.60713,358.42075l-0.27524,1.23857l2.56888,0.55047l0.27524,-1.23857l-2.56888,-0.55047z",
    className: "st7"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    d: "m592.61592,362.73279l-0.27524,1.23857l2.56888,0.55047l0.27524,-1.23857l-2.56888,-0.55047z",
    className: "st7"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    d: "m550.87166,458.60697l-16.00961,0c-0.87158,0 -1.55968,-0.68809 -1.55968,-1.55968l0,-20.13817c0,-0.87158 0.68809,-1.55968 1.55968,-1.55968l16.00961,0c0.87158,0 1.55968,0.68809 1.55968,1.55968l0,20.13817c0,0.87158 -0.73397,1.55968 -1.55968,1.55968z",
    className: "st7"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    d: "m550.87166,458.60697l-16.00961,0c-0.87158,0 -1.55968,-0.68809 -1.55968,-1.55968l0,-20.13817c0,-0.87158 0.68809,-1.55968 1.55968,-1.55968l16.00961,0c0.87158,0 1.55968,0.68809 1.55968,1.55968l0,20.13817c0,0.87158 -0.73397,1.55968 -1.55968,1.55968z",
    className: "st7"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    d: "m549.86246,436.77151l-13.99121,0l0,18.94547l13.99121,0l0,-18.94547z",
    className: "st7"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    fill: "#FFFFFF",
    opacity: 0.7,
    d: "m549.86246,436.77151l-13.99121,0l0,18.94547l13.99121,0l0,-18.94547z",
    className: "st16"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    d: "m544.95407,434.61549c-0.18349,0 -0.36698,-0.09175 -0.41286,-0.32111c-0.22936,-0.68809 -0.87158,-1.14682 -1.65142,-1.14682s-1.42206,0.5046 -1.65142,1.14682c-0.04587,0.18349 -0.22936,0.32111 -0.41286,0.32111l-2.2019,0c-0.27524,0 -0.45873,0.22936 -0.45873,0.45873l0,2.43126c0,0.27524 0.22936,0.45873 0.45873,0.45873l8.48647,0c0.27524,0 0.45873,-0.22936 0.45873,-0.45873l0,-2.43126c0,-0.27524 -0.22936,-0.45873 -0.45873,-0.45873l-2.15602,0z",
    className: "st7"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    opacity: 0.5,
    d: "m544.95407,434.61549c-0.18349,0 -0.36698,-0.09175 -0.41286,-0.32111c-0.22936,-0.68809 -0.87158,-1.14682 -1.65142,-1.14682s-1.42206,0.5046 -1.65142,1.14682c-0.04587,0.18349 -0.22936,0.32111 -0.41286,0.32111l-2.2019,0c-0.27524,0 -0.45873,0.22936 -0.45873,0.45873l0,2.43126c0,0.27524 0.22936,0.45873 0.45873,0.45873l8.48647,0c0.27524,0 0.45873,-0.22936 0.45873,-0.45873l0,-2.43126c0,-0.27524 -0.22936,-0.45873 -0.45873,-0.45873l-2.15602,0z",
    className: "st15"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    d: "m547.4312,441.63403l-9.12869,0c-0.27524,0 -0.5046,-0.22936 -0.5046,-0.5046c0,-0.27524 0.22936,-0.5046 0.5046,-0.5046l9.12869,0c0.27524,0 0.5046,0.22936 0.5046,0.5046c0,0.27524 -0.22936,0.5046 -0.5046,0.5046z",
    className: "st7"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    d: "m547.4312,446.4048l-9.12869,0c-0.27524,0 -0.5046,-0.22936 -0.5046,-0.5046c0,-0.27524 0.22936,-0.5046 0.5046,-0.5046l9.12869,0c0.27524,0 0.5046,0.22936 0.5046,0.5046c0,0.27524 -0.22936,0.5046 -0.5046,0.5046z",
    className: "st7"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    d: "m543.30264,451.22145l-5.00014,0c-0.27524,0 -0.5046,-0.22936 -0.5046,-0.5046c0,-0.27524 0.22936,-0.5046 0.5046,-0.5046l5.00014,0c0.27524,0 0.5046,0.22936 0.5046,0.5046c0,0.27524 -0.22936,0.5046 -0.5046,0.5046z",
    className: "st7"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#21252B",
    d: "m406.87689,573.05964c0.55047,1.97253 0.68809,2.75237 0.59635,4.67903l0.04587,13.1655c-0.09175,2.29364 -0.73397,4.54141 -1.92666,6.51394l-0.27524,0.45873c-0.68809,1.19269 -2.0184,1.88079 -3.44046,1.88079l-3.94506,0c-1.83491,0 -3.39459,-1.19269 -3.85332,-2.84411c-0.5046,-1.92666 -0.59635,-3.99093 -0.18349,-5.96347l3.34872,-14.12883c0.22936,-1.19269 0.55047,-2.56888 1.19269,-3.80744l8.4406,0.04587z",
    className: "st11"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FC9D9D",
    d: "m460.41047,542.14137l2.47713,25.1383c0.13762,2.98173 0.91746,4.77077 1.83491,6.00934l9.54155,18.57849l-2.66062,3.48633l-10.41313,-4.95426l-9.26631,-15.96374c0.04587,-2.7065 -0.27524,-4.40379 -0.77984,-8.02774l-4.58728,-27.15671l13.85359,2.88999z",
    className: "st17"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    opacity: 0.15,
    d: "m463.11696,575.72027c-1.05507,-1.5138 -2.43126,-5.00014 -2.7065,-6.65156l-3.2111,-9.31218c-0.09175,-0.64222 -0.64222,-1.19269 -1.33031,-1.28444l-6.33045,-0.82571l-0.09175,-1.33031l12.38566,0l1.05507,11.00948c0.22936,1.92666 0.68809,4.35792 1.88079,6.00934l9.54155,18.57849l-1.65142,2.56888l-9.54155,-18.76198z",
    className: "st13"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#21252B",
    d: "m479.7688,595.07859l-5.50474,-3.16522c-3.94506,0.59635 -7.98187,-0.82571 -10.50487,-3.76157l-11.83519,-13.71597c-2.15602,4.35792 -2.88999,9.26631 -2.15602,14.03708l1.74317,11.37646l1.37618,0l0.36698,-11.69757c0.04587,-0.87158 1.14682,-1.23857 1.69729,-0.55047l7.2479,8.4406c2.06428,2.38539 5.13776,3.80744 8.39472,3.80744l11.28471,0c0.87158,0 1.46793,-0.87158 1.14682,-1.65142c-0.68809,-1.37618 -1.83491,-2.47713 -3.25697,-3.11935z",
    className: "st11"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FC9D9D",
    d: "m407.42737,567.18792c-0.59635,4.7249 -0.82571,9.49567 -0.77984,14.26645l0.09175,5.68823c-0.09175,2.47713 -2.24777,4.49554 -4.86252,4.49554l-0.82571,0c-2.93586,0 -5.2295,-2.47713 -4.81665,-5.27537l1.37618,-6.7433c0.68809,-3.44046 0.96333,-6.92679 0.73397,-10.41313l-1.33031,-22.93641l12.43153,0.18349l-2.0184,20.73451z",
    className: "st17"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    d: "m454.9516,390.8987l1.74317,20.27578l1.55968,16.97294c0.82571,9.03694 1.37618,18.11976 1.65142,27.15671l2.61475,101.01194l-13.57835,0l-21.74371,-136.19639c-0.13762,-0.96333 -1.05507,-1.69729 -2.06428,-1.69729c-1.10095,0 -2.0184,0.82571 -2.11015,1.83491l-13.6701,136.05877l-12.33979,-0.09175l-4.54141,-95.59894c-1.28444,-22.34006 0.45873,-44.72599 5.27537,-66.6532l0.82571,-3.07348l56.37769,0l0,0z",
    className: "st7"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    opacity: 0.15,
    d: "m408.48244,556.31607c0,0 -1.46793,14.72517 -1.60555,16.6977l0,0.04587c-0.18349,2.75237 -0.27524,5.55061 -0.22936,8.34885l0.09175,5.68823c-0.09175,2.43126 -2.11015,4.35792 -4.63315,4.44966c2.29364,-1.69729 2.06428,-4.44966 2.15602,-6.46807l0.36698,-24.95481c0,-0.82571 -0.59635,-1.5138 -1.42206,-1.65142l-5.55061,-0.96333l-0.04587,-1.14682l10.87186,-0.04587z",
    className: "st13"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    opacity: 0.2,
    d: "m425.0884,418.42239c-0.55047,0 -1.05507,0.18349 -1.42206,0.55047c-0.36698,0.32111 -0.64222,0.77984 -0.68809,1.33031l-13.6701,136.05877l-4.40379,-0.04587l9.03694,-127.75579c0.27524,-5.68823 5.18363,-10.13789 11.14709,-10.13789z",
    className: "st18"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    opacity: 0.2,
    d: "m455.36446,395.85296l1.33031,15.27565l0.96333,10.55075c1.23857,13.30312 2.06428,26.6521 2.43126,40.00109l2.43126,94.58974l-6.05521,0l-6.28458,-135.3248l-1.42206,-25.96401l6.55981,0l0.04587,0.87158z",
    className: "st18"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#21252B",
    d: "m455.31859,395.02725l-0.45873,-5.18363l-56.01071,-0.13762l-1.37618,5.32125l57.84562,0l0,0z",
    className: "st11"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#21252B",
    d: "m424.40031,289.6574c2.79824,-1.42206 4.95426,-4.03681 5.68823,-7.38552c1.0092,-4.63315 -1.0092,-9.22044 -4.77077,-11.55995c2.79824,-0.41286 5.18363,-2.7065 5.45886,-5.91759c0.22936,-2.88999 -1.5138,-5.64236 -4.2203,-6.60569c-3.62395,-1.28444 -7.4314,0.96333 -8.25711,4.67903c-0.18349,0.91746 -0.18349,1.83491 -0.04587,2.7065c0.36698,1.78904 -0.59635,3.53221 -2.29364,4.12855c-3.30284,1.23857 -6.00934,4.08268 -6.65156,7.84425c-1.19269,6.92679 2.47713,10.32138 5.59648,11.88106c1.60555,0.82571 2.33951,2.66062 1.78904,4.40379c-0.13762,0.41286 -0.22936,0.87158 -0.27524,1.28444c-0.36698,3.11935 1.60555,6.14696 4.58728,6.97267c3.53221,0.96333 7.06441,-1.23857 7.84425,-4.81665c0.82571,-3.34872 -1.19269,-6.69743 -4.44966,-7.61489z",
    className: "st11"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    d: "m428.11601,271.85875c2.93586,0 5.27537,-2.43126 5.27537,-5.41299s-2.38539,-5.41299 -5.27537,-5.41299c-2.88999,0 -5.27537,2.43126 -5.27537,5.41299s2.38539,5.41299 5.27537,5.41299z",
    className: "st7"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#21252B",
    d: "m433.85011,291.62993c7.84425,0 14.22057,-6.51394 14.22057,-14.54168s-6.37632,-14.54168 -14.22057,-14.54168c-7.84425,0 -14.22057,6.51394 -14.22057,14.54168s6.37632,14.54168 14.22057,14.54168z",
    className: "st11"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#F39494",
    d: "m445.08895,307.86891l-4.90839,2.93586c-0.82571,0.5046 -1.69729,0.91746 -2.56888,1.23857c-4.86252,1.88079 -10.36726,1.42206 -14.90866,-1.37618l-4.49554,-2.75237l1.97253,-0.55047c1.33031,-0.36698 2.29364,-1.60555 2.33951,-2.98173l0.45873,-17.24818l15.32152,-3.07348l1.74317,15.73438l0.36698,3.57808l0.13762,1.28444c0.13762,1.23857 1.05507,2.33951 2.29364,2.7065l2.24777,0.5046z",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#F39494",
    d: "m435.59328,300.52926l-0.82571,0c-5.91759,-0.18349 -10.50487,-5.2295 -10.32138,-11.23884l0.5046,-15.27565c0.04587,-2.0184 1.69729,-3.57808 3.66983,-3.53221l13.94534,0.41286c2.523,0.09175 4.54141,2.24777 4.44966,4.86252l-0.45873,14.1747c-0.22936,6.05521 -5.13776,10.82598 -10.9636,10.59662z",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#21252B",
    d: "m435.63915,285.02424c0.64222,0 1.14682,-0.55047 1.14682,-1.19269s-0.5046,-1.19269 -1.14682,-1.19269s-1.14682,0.55047 -1.14682,1.19269s0.5046,1.19269 1.14682,1.19269z",
    className: "st11"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FFFFFF",
    d: "m436.14375,283.87742c0.13762,0 0.22936,-0.09175 0.22936,-0.22936c0,-0.13762 -0.09175,-0.22936 -0.22936,-0.22936c-0.13762,0 -0.22936,0.09175 -0.22936,0.22936c0,0.13762 0.09175,0.22936 0.22936,0.22936z",
    className: "st6"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#21252B",
    d: "m444.58435,285.66646c0.64222,0 1.14682,-0.55047 1.14682,-1.19269s-0.5046,-1.19269 -1.14682,-1.19269s-1.14682,0.55047 -1.14682,1.19269s0.5046,1.19269 1.14682,1.19269z",
    className: "st11"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FFFFFF",
    d: "m445.08895,284.51964c0.13762,0 0.22936,-0.09175 0.22936,-0.22936s-0.09175,-0.22936 -0.22936,-0.22936c-0.13762,0 -0.22936,0.09175 -0.22936,0.22936s0.09175,0.22936 0.22936,0.22936z",
    className: "st6"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    opacity: 0.3,
    className: "st19"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    opacity: 0.3,
    d: "m439.90532,291.03358l-1.55968,0.04587c-0.18349,0 -0.32111,-0.18349 -0.36698,-0.32111c0,-0.18349 0.18349,-0.32111 0.32111,-0.36698l1.55968,-0.04587c0.36698,0 0.68809,-0.32111 0.68809,-0.73397s-0.32111,-0.73397 -0.73397,-0.73397c-0.18349,0 -0.32111,-0.18349 -0.36698,-0.32111c0,-0.18349 0.18349,-0.32111 0.32111,-0.36698c0.77984,0 1.37618,0.64222 1.37618,1.37618c0.18349,0.82571 -0.45873,1.46793 -1.23857,1.46793z",
    className: "st20"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    opacity: 0.15,
    d: "m422.88651,289.33629l1.69729,0.73397l-1.74317,3.11935l0.04587,-3.85332z",
    className: "st13"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    opacity: 0.15,
    d: "m440.45579,303.28162c-0.77984,0.09175 -1.55968,0.13762 -2.38539,0.04587c-2.47713,-0.27524 -4.31204,-1.5138 -5.36712,-2.47713c-2.15602,-0.45873 -3.7157,-1.33031 -4.67903,-2.06428c-0.13762,-0.09175 -0.13762,-0.32111 -0.04587,-0.45873c0.09175,-0.13762 0.32111,-0.18349 0.45873,-0.04587c0.77984,0.55047 1.92666,1.28444 3.57808,1.74317c0.09175,0 0.18349,0.04587 0.27524,0.09175c0.27524,0.09175 0.5046,0.09175 0.77984,0.18349c0.04587,0 0.04587,0 0.09175,0c0.13762,0.04587 0.32111,0.09175 0.45873,0.09175c0.41286,0.04587 0.87158,0.09175 1.28444,0.13762c1.83491,0.09175 3.57808,-0.09175 5.18363,-0.73397l0.36698,3.48633z",
    className: "st13"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FFFFFF",
    d: "m440.18056,292.45564c0.13762,0 0.22936,0.18349 0.18349,0.32111c-0.64222,1.10095 -1.78904,1.78904 -3.07348,1.74317c-1.28444,-0.04587 -2.33951,-0.91746 -2.84411,-2.06428c-0.04587,-0.13762 0,-0.27524 0.22936,-0.27524l5.50474,0.27524z",
    className: "st6"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#21252B",
    d: "m423.71222,281.53791c1.74317,-1.33031 4.40379,-0.73397 6.46807,-0.68809c7.4314,0.18349 11.10122,-4.49554 11.4682,-9.49567c0.13762,-1.74317 -0.22936,-3.44046 -0.96333,-4.86252c-0.27524,-0.5046 -2.11015,-0.82571 -2.11015,-0.82571l-16.65183,3.7157l0.27524,6.78918l1.5138,5.36712z",
    className: "st11"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#21252B",
    d: "m438.80437,273.00557c5.18363,0.41286 8.57822,3.02761 8.16536,8.30298c0,0.09175 0,0.18349 -0.04587,0.27524l0.5046,-7.11029l-2.0184,-3.66983l-7.70663,-0.18349l1.10095,2.38539z",
    className: "st11"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#21252B",
    d: "m492.7508,344.61303l-1.46793,10.59662l-25.04656,7.70663c-5.13776,1.55968 -10.78011,-0.59635 -13.30312,-5.36712c-0.09175,-0.18349 -0.18349,-0.36698 -0.27524,-0.55047l-18.02802,-38.90015l25.6429,-0.13762l8.16536,30.78066l24.31259,-4.12855z",
    className: "st11"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    opacity: 0.3,
    d: "m460.22698,317.96092l-5.82585,10.87186c0,0 -5.36712,15.22977 -6.19283,19.35833c0,0 4.26617,8.9452 6.19283,11.60582c1.37618,1.83491 2.43126,1.23857 2.43126,1.23857l3.16522,-9.86266l2.93586,-5.82585c2.33951,-4.67903 2.75237,-10.09202 1.19269,-15.13803l-3.89919,-12.24804z",
    className: "st20"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    d: "m431.87758,324.61248c7.98187,0 14.49581,-6.97267 14.49581,-15.78025l-1.69729,-0.41286l0,0.22936c0,7.84425 -5.7341,14.22057 -12.75264,14.22057c-7.01854,0 -12.75264,-6.37632 -12.75264,-14.22057l0,-0.22936l-1.69729,0.5046c0.09175,8.71583 6.51394,15.6885 14.40406,15.6885z",
    className: "st7"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    d: "m431.87758,324.61248c7.98187,0 14.49581,-6.97267 14.49581,-15.78025l-1.69729,-0.41286l0,0.22936c0,7.84425 -5.7341,14.22057 -12.75264,14.22057c-7.01854,0 -12.75264,-6.37632 -12.75264,-14.22057l0,-0.22936l-1.69729,0.36698c0.09175,8.66996 6.51394,15.82612 14.40406,15.82612z",
    className: "st7"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    opacity: 0.6,
    className: "st21"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    opacity: 0.6,
    d: "m431.87758,324.61248c7.98187,0 14.49581,-6.97267 14.49581,-15.78025l-1.69729,-0.41286l0,0.22936c0,7.84425 -5.7341,14.22057 -12.75264,14.22057c-7.01854,0 -12.75264,-6.37632 -12.75264,-14.22057l0,-0.22936l-1.69729,0.36698c0.09175,8.66996 6.51394,15.82612 14.40406,15.82612z",
    className: "st22"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#21252B",
    d: "m403.52818,311.85984l16.60596,-5.04601l23.48688,0.13762l8.80758,2.98173c2.88999,0.91746 5.18363,2.98173 6.69743,5.55061c1.69729,2.88999 2.15602,6.37632 1.5138,9.67916l-0.36698,1.97253l2.24777,7.75251c1.33031,5.04601 -0.41286,7.936 -3.89919,11.9728c-1.10095,1.28444 -1.69729,1.78904 -2.11015,4.2203c0,0 -2.11015,7.98187 -2.523,11.28471c-1.5138,12.93613 -3.44046,21.88133 -3.44046,21.88133l-42.15712,0.64222c-2.06428,0 -2.93586,-2.2019 -1.97253,-3.99093c0,0 3.02761,-6.05521 3.62395,-11.14709c1.83491,-16.65183 -2.88999,-36.51476 -2.88999,-36.51476l-12.20217,-10.459l0.55047,-2.33951c0.91746,-4.12855 3.99093,-7.38552 8.02774,-8.57822z",
    className: "st11"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FBFBFB",
    d: "m422.19841,305.8505l-3.94506,1.55968l6.37632,15.59676l6.2387,-3.34872l-8.66996,-13.80772z",
    className: "st23"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#F39494",
    d: "m422.61127,306.49272l8.25711,13.1655l8.71583,11.65169l1.74317,-24.81719c0,0 -10.13789,-5.13776 -18.71611,0z",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FBFBFB",
    d: "m441.14389,306.03399l-0.82571,14.49581l6.55981,6.10108l-2.88999,-19.58769l-2.84411,-1.0092z",
    className: "st23"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    opacity: 0.3,
    d: "m448.43766,337.77798l-4.44966,-30.73479l2.56888,0.87158l4.26617,8.71583l-2.88999,1.28444l6.88092,2.61475l-2.11015,17.93627l-4.26617,-0.68809z",
    className: "st20"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#61656D",
    d: "m421.73969,333.55768l40.18459,6.37632l-12.61502,46.97376l-40.04697,-6.92679l12.47741,-46.42329z",
    className: "st24"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#AEB2B7",
    d: "m435.96026,340.20924c0.59635,0 1.10095,-0.5046 1.10095,-1.10095s-0.5046,-1.10095 -1.10095,-1.10095s-1.10095,0.5046 -1.10095,1.10095s0.5046,1.10095 1.10095,1.10095z",
    className: "st25"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#AEB2B7",
    d: "m447.24497,341.86066c0.59635,0 1.10095,-0.5046 1.10095,-1.10095c0,-0.59635 -0.5046,-1.10095 -1.10095,-1.10095s-1.10095,0.5046 -1.10095,1.10095c0.04587,0.64222 0.5046,1.10095 1.10095,1.10095z",
    className: "st25"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    opacity: 0.3,
    d: "m419.3543,342.45701l-7.936,-20.45928l5.36712,-2.33951l-4.2203,-0.73397l1.42206,-10.13789l2.98173,-0.96333l8.25711,26.331l-3.48633,-0.55047l-2.38539,8.85345z",
    className: "st20"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#125975",
    d: "m408.29895,359.8428c0,-0.18349 -0.91746,-17.3858 -3.76157,-28.48702l0.45873,-0.09175c2.84411,11.19297 3.76157,28.39527 3.76157,28.57876l-0.45873,0z",
    className: "st26"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FBFBFB",
    d: "m445.04308,390.3941l-23.71624,-0.13762l0,-8.39472l23.71624,4.49554l0,4.03681z",
    className: "st23"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#21252B",
    d: "m394.94996,322.77757l-8.57822,49.35915c-0.45873,2.15602 0.18349,4.35792 1.74317,5.91759c2.523,2.47713 6.55981,2.47713 9.03694,0l7.47727,-7.47727l1.23857,-11.55995l5.55061,-25.32179l-16.46834,-10.91773z",
    className: "st11"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#21252B",
    d: "m401.83089,374.79734c-1.23857,5.91759 -7.936,26.23925 -8.48647,43.62505l18.94547,0c5.00014,0 9.03694,-4.03681 9.03694,-9.03694l0,-27.52369l-12.06455,-1.88079l3.2111,-12.01868l-3.2111,-24.1291l-7.4314,30.96415z",
    className: "st11"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#21252B",
    d: "m453.80478,370.21006c0,0 -0.13762,12.38566 2.61475,26.19338c1.19269,6.05521 2.0184,15.82612 2.11015,21.78959c0,1.19269 -0.91746,2.15602 -2.11015,2.15602l-4.81665,0c-5.00014,0 -9.03694,-4.03681 -9.03694,-9.03694l0.22936,-25.50528l6.51394,1.14682l4.49554,-16.74358z",
    className: "st11"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#F39494",
    d: "m404.76675,370.43942l7.33965,-7.33965l4.67903,0.27524l7.89012,-1.05507c0.55047,0 1.0092,-0.45873 1.0092,-1.0092l0,-0.32111c0,-0.55047 -0.45873,-1.0092 -1.05507,-1.0092l-6.60569,0l8.34885,0c0.55047,0 1.0092,-0.45873 1.0092,-1.0092l0,-0.27524c0,-0.55047 -0.45873,-1.0092 -1.0092,-1.0092l-8.57822,0l10.04615,0c0.55047,0 1.0092,-0.45873 1.0092,-1.0092l0,-0.13762c0,-0.55047 -0.45873,-1.0092 -1.0092,-1.0092l-10.18376,0l3.89919,-1.10095c0.04587,0 0.09175,0 0.13762,-0.04587l5.50474,-0.73397c0.5046,-0.04587 0.91746,-0.5046 0.91746,-1.0092c0,-0.59635 -0.5046,-1.10095 -1.14682,-1.0092l-10.22964,0.96333c-0.09175,0 -0.18349,0.04587 -0.27524,0.04587l-10.50487,6.42219l-1.19269,11.37646z",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    opacity: 0.3,
    d: "m412.1064,363.14565l-9.77091,9.77091l-1.46793,5.96347l11.92693,-11.88106l1.0092,-3.76157l-1.69729,-0.09175z",
    className: "st20"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FBFBFB",
    d: "m425.22602,334.10816l-8.25711,-26.331l2.47713,-0.87158l11.37646,12.70677l6.37632,6.46807l3.11935,-5.59648l6.55981,6.10108l1.5138,11.14709l-23.16577,-3.62395z",
    className: "st23"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    opacity: 0.3,
    d: "m424.62967,323.00693l6.2387,-3.34872l6.37632,6.46807l-6.37632,-4.17443l-6.2387,1.05507z",
    className: "st20"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    opacity: 0.3,
    d: "m445.77704,323.60328l-5.45886,-3.07348l-3.11935,5.59648l2.7065,-3.99093l5.87172,1.46793z",
    className: "st20"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#F39494",
    d: "m512.38437,350.75999l-9.67916,0.09175l-11.4682,4.35792l1.5138,-10.59662l10.00027,-1.46793c0,0 0.41286,-2.47713 5.36712,-3.11935l4.31204,-2.0184c0,0 1.28444,1.05507 0.27524,2.43126s-1.92666,1.46793 -1.92666,1.46793l3.44046,-0.77984l-0.68809,2.2019l1.37618,2.56888l-0.59635,2.11015l-1.92666,2.75237z",
    className: "st0"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    opacity: 0.3,
    className: "st19"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    opacity: 0.3,
    d: "m426.32697,357.91615l-8.57822,0c-0.13762,0 -0.22936,-0.09175 -0.22936,-0.22936s0.09175,-0.22936 0.22936,-0.22936l8.57822,0c0.13762,0 0.22936,0.09175 0.22936,0.22936c0.04587,0.13762 -0.09175,0.22936 -0.22936,0.22936z",
    className: "st20"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    opacity: 0.3,
    className: "st19"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    opacity: 0.3,
    d: "m417.97812,360.25566c-0.13762,0 -0.22936,-0.09175 -0.22936,-0.22936c0,-0.13762 0.09175,-0.22936 0.22936,-0.22936l6.65156,-0.04587c0.13762,0 0.22936,0.09175 0.22936,0.22936s-0.09175,0.22936 -0.22936,0.22936l-6.65156,0.04587z",
    className: "st20"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#21252B",
    d: "m537.4768,297.77689c-10.68837,-5.55061 -23.85386,-1.37618 -29.40447,9.26631c-5.55061,10.68837 -1.37618,23.85386 9.26631,29.40447c10.68837,5.55061 23.85386,1.37618 29.40447,-9.26631c5.55061,-10.68837 1.42206,-23.85386 -9.26631,-29.40447zm-18.44087,35.41381c-8.85345,-4.58728 -12.29391,-15.50501 -7.70663,-24.40434s15.50501,-12.29391 24.40434,-7.70663c8.85345,4.63315 12.29391,15.55088 7.70663,24.40434c-4.58728,8.85345 -15.50501,12.29391 -24.40434,7.70663z",
    className: "st11"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#21252B",
    d: "m505.73281,357.73265l12.84439,-23.71624l3.53221,1.83491l-12.61502,23.94561c-0.22936,0.41286 -0.73397,0.59635 -1.14682,0.36698l-2.24777,-1.23857c-0.41286,-0.27524 -0.59635,-0.77984 -0.36698,-1.19269z",
    className: "st11"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#3F4249",
    d: "m508.53105,359.24646l12.56915,-23.85386l-4.81665,-1.69729l-12.20217,23.1199c-0.22936,0.41286 -0.04587,0.91746 0.36698,1.14682l2.93586,1.65142c0.41286,0.22936 0.96333,0.04587 1.14682,-0.36698z",
    className: "st27"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    opacity: 0.3,
    d: "m516.28356,333.6953l-1.5138,2.88999c0.36698,0.18349 0.68809,0.41286 1.05507,0.59635c1.14682,0.59635 2.38539,1.10095 3.57808,1.46793l1.69729,-3.25697l-4.81665,-1.69729z",
    className: "st20"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#3F4249",
    d: "m536.2841,297.31816c-10.68837,-5.55061 -23.85386,-1.37618 -29.40447,9.26631c-5.55061,10.68837 -1.37618,23.85386 9.26631,29.40447c10.68837,5.55061 23.85386,1.37618 29.40447,-9.26631c5.55061,-10.68837 1.42206,-23.85386 -9.26631,-29.40447zm-18.395,35.41381c-8.85345,-4.63315 -12.29391,-15.55088 -7.70663,-24.40434c4.58728,-8.85345 15.50501,-12.29391 24.40434,-7.70663c8.85345,4.63315 12.29391,15.55088 7.70663,24.40434c-4.63315,8.85345 -15.55088,12.29391 -24.40434,7.70663z",
    className: "st27"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#F39494",
    d: "m517.01752,347.96175c-0.41286,0.5046 -1.19269,0.55047 -1.65142,0.13762l-2.2019,-1.97253c-0.41286,-0.41286 -1.10095,-0.41286 -1.5138,0c-0.45873,0.41286 -0.45873,1.14682 -0.04587,1.55968l1.92666,1.97253c0.41286,0.45873 1.10095,0.5046 1.60555,0.09175c0.59635,-0.45873 0.64222,-1.33031 0.04587,-1.83491l-2.38539,-2.11015c-0.41286,-0.36698 -0.45873,-1.0092 -0.09175,-1.46793c0.36698,-0.41286 1.0092,-0.5046 1.46793,-0.13762l2.66062,2.15602c0.5046,0.36698 0.59635,1.10095 0.18349,1.60555z",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#F39494",
    d: "m518.0726,344.1543l-3.57808,-2.15602c-0.41286,-0.22936 -0.91746,-0.13762 -1.19269,0.18349c-0.32111,0.41286 -0.27524,1.0092 0.13762,1.33031l3.25697,2.61475c0.59635,0.45873 1.42206,0.32111 1.83491,-0.32111c0.32111,-0.5046 0.13762,-1.28444 -0.45873,-1.65142z",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#F39494",
    d: "m518.02672,343.19097l-4.03681,-1.5138c-0.41286,-0.13762 -0.68809,-0.59635 -0.55047,-1.05507c0.13762,-0.5046 0.59635,-0.77984 1.10095,-0.64222l4.12855,1.10095c0.59635,0.13762 0.91746,0.77984 0.77984,1.37618c-0.18349,0.59635 -0.82571,0.96333 -1.42206,0.73397z",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    opacity: 0.3,
    d: "m516.74228,343.32859l-2.24777,-1.37618c-0.36698,-0.22936 -0.82571,-0.18349 -1.10095,0.09175c-0.41286,0.36698 -0.41286,1.05507 0,1.42206l1.55968,1.33031l-0.82571,-0.64222c-0.41286,-0.32111 -0.96333,-0.32111 -1.37618,0c-0.45873,0.41286 -0.45873,1.10095 -0.04587,1.5138l0.36698,0.41286c-0.41286,-0.41286 -1.10095,-0.41286 -1.55968,0c-0.41286,0.41286 -0.45873,1.14682 0,1.55968l0.41286,0.41286l1.60555,1.69729l-2.29364,-1.23857c-0.73397,-0.36698 -1.0092,-1.23857 -0.68809,-1.97253l2.75237,-5.96347c0.22936,-0.45873 0.73397,-0.73397 1.23857,-0.59635l-0.04587,0c-0.41286,-0.09175 -0.82571,0.13762 -1.0092,0.5046c-0.18349,0.45873 0.04587,1.0092 0.5046,1.19269l3.02761,1.19269l-0.27524,0.45873z",
    className: "st20"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    opacity: 0.15,
    className: "st28"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    opacity: 0.15,
    d: "m509.03565,345.98921c-0.09175,0 -0.22936,-0.04587 -0.27524,-0.13762c-0.09175,-0.18349 -0.09175,-0.36698 0.09175,-0.5046c1.92666,-1.33031 1.65142,-3.34872 1.65142,-3.34872c-0.04587,-0.18349 0.09175,-0.36698 0.27524,-0.41286c0.18349,-0.04587 0.36698,0.09175 0.41286,0.27524c0,0.09175 0.36698,2.47713 -1.92666,4.08268c-0.09175,0 -0.18349,0.04587 -0.22936,0.04587z",
    className: "st13"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    d: "m421.09747,270.66605c-1.37618,1.0092 -4.90839,9.86266 -0.73397,15.6885c0,0 -0.68809,-2.29364 0.73397,-4.26617c0,0 -2.88999,-3.76157 0,-11.42233z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#FFFFFF",
    d: "m445.13482,281.03331c-1.42206,0.04587 -2.75237,0.73397 -3.57808,1.78904c-1.28444,-0.55047 -2.38539,-0.32111 -2.88999,-0.18349c-0.77984,-1.5138 -2.29364,-2.56888 -4.12855,-2.56888c-2.56888,0 -4.63315,2.15602 -4.63315,4.77077c0,2.61475 2.11015,4.7249 4.67903,4.7249c2.56888,0 4.63315,-2.15602 4.63315,-4.77077c0,-0.55047 -0.09175,-1.05507 -0.27524,-1.55968c0.45873,-0.09175 1.37618,-0.22936 2.29364,0.13762c-0.45873,0.68809 -0.64222,1.55968 -0.64222,2.47713c0,2.61475 2.11015,4.7249 4.63315,4.7249c2.56888,0 4.63315,-2.15602 4.63315,-4.77077c-0.04587,-2.56888 -2.15602,-4.7249 -4.7249,-4.77077zm-10.50487,7.936c-2.2019,0.04587 -3.99093,-1.83491 -4.03681,-4.08268c-0.04587,-2.24777 1.78904,-4.08268 3.99093,-4.12855c2.2019,-0.04587 3.99093,1.83491 4.03681,4.08268c0,2.24777 -1.83491,4.12855 -3.99093,4.12855zm10.55075,1.0092c-2.2019,0.04587 -3.99093,-1.83491 -4.03681,-4.08268s1.78904,-4.08268 3.99093,-4.12855s3.99093,1.83491 4.03681,4.08268s-1.74317,4.08268 -3.99093,4.12855z",
    className: "st6"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#F39494",
    d: "m425.18015,289.97851c0,0 -4.58728,-0.18349 -5.04601,-4.86252c-0.45873,-4.7249 5.2295,-4.95426 5.50474,-0.18349l-0.04587,5.09188l-0.41286,-0.04587z",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    opacity: 0.3,
    d: "m421.83143,282.86822c0.55047,-0.27524 1.0092,-0.32111 1.42206,-0.22936c0.41286,0.13762 0.73397,0.45873 1.0092,1.0092c0.22936,0.55047 0.36698,1.19269 0.32111,1.88079l-0.04587,0.45873c-0.04587,0.36698 -0.64222,0.41286 -0.59635,-0.04587c0,-0.55047 0,-0.55047 0,-0.55047c0.04587,-0.18349 0,-1.0092 -0.22936,-1.5138c-0.18349,-0.41286 -0.41286,-0.64222 -0.64222,-0.73397s-0.55047,0 -0.96333,0.18349c-0.13762,0.04587 -0.32111,0 -0.41286,-0.13762c-0.09175,-0.09175 -0.04587,-0.27524 0.13762,-0.32111z",
    className: "st20"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    d: "m424.0792,289.1528c0.5046,0 0.91746,-0.41286 0.91746,-0.91746s-0.41286,-0.91746 -0.91746,-0.91746c-0.5046,0 -0.91746,0.41286 -0.91746,0.91746s0.45873,0.91746 0.91746,0.91746z",
    className: "st7"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    opacity: 0.15,
    d: "m424.35444,289.06105c-0.55047,-0.04587 -0.96333,-0.55047 -0.87158,-1.10095c0.04587,-0.18349 0.13762,-0.36698 0.22936,-0.5046c-0.22936,0.13762 -0.41286,0.41286 -0.5046,0.73397c-0.04587,0.5046 0.32111,0.96333 0.82571,1.0092c0.18349,0.04587 0.41286,0 0.55047,-0.09175c-0.09175,-0.09175 -0.18349,-0.09175 -0.22936,-0.04587z",
    className: "st13"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    enableBackground: "new",
    opacity: 0.3,
    d: "m401.55565,360.25566l-9.08282,5.04601c-0.13762,0.09175 -0.22936,0.22936 -0.22936,0.36698c0,0.32111 0.36698,0.55047 0.64222,0.36698l12.98201,-7.06441l2.38539,-16.1931c0.04587,-0.22936 -0.32111,-0.32111 -0.41286,-0.09175l-6.28458,17.56929z",
    className: "st20"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#ADB1B6",
    d: "m798.08025,599.84937c0.18349,0 0.36698,0.13762 0.36698,0.36698s-0.18349,0.36698 -0.41286,0.36698",
    className: "st29"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#ADB1B6",
    d: "m259.71691,600.58333c-0.18349,0 -0.36698,-0.13762 -0.36698,-0.36698s0.18349,-0.36698 0.36698,-0.36698",
    className: "st29"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#868A91",
    d: "m661.56276,463.90528l-87.15835,0c-1.0092,0 -1.83491,-0.82571 -1.83491,-1.83491l0,-0.13762c0,-1.0092 0.82571,-1.83491 1.83491,-1.83491l87.15835,0c1.0092,0 1.83491,0.82571 1.83491,1.83491l0,0.13762c0,1.0092 -0.82571,1.83491 -1.83491,1.83491z",
    className: "st10"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#868A91",
    d: "m615.0936,478.03411l-40.64331,0c-1.05507,0 -1.88079,-0.87158 -1.88079,-1.88079c0,-1.05507 0.82571,-1.88079 1.88079,-1.88079l40.64331,0c1.05507,0 1.88079,0.87158 1.88079,1.88079s-0.82571,1.88079 -1.88079,1.88079z",
    className: "st10"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#868A91",
    d: "m661.56276,488.01603l-87.15835,0c-1.0092,0 -1.83491,-0.82571 -1.83491,-1.83491l0,-0.13762c0,-1.0092 0.82571,-1.83491 1.83491,-1.83491l87.15835,0c1.0092,0 1.83491,0.82571 1.83491,1.83491l0,0.13762c0,1.0092 -0.82571,1.83491 -1.83491,1.83491z",
    className: "st10"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#868A91",
    d: "m615.0936,502.14486l-40.64331,0c-1.05507,0 -1.88079,-0.87158 -1.88079,-1.88079c0,-1.05507 0.82571,-1.88079 1.88079,-1.88079l40.64331,0c1.05507,0 1.88079,0.87158 1.88079,1.88079s-0.82571,1.88079 -1.88079,1.88079z",
    className: "st10"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#868A91",
    d: "m661.56276,512.12678l-87.15835,0c-1.0092,0 -1.83491,-0.82571 -1.83491,-1.83491l0,-0.13762c0,-1.0092 0.82571,-1.83491 1.83491,-1.83491l87.15835,0c1.0092,0 1.83491,0.82571 1.83491,1.83491l0,0.13762c0,1.0092 -0.82571,1.83491 -1.83491,1.83491z",
    className: "st10"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#868A91",
    d: "m615.0936,526.25561l-40.64331,0c-1.05507,0 -1.88079,-0.87158 -1.88079,-1.88079c0,-1.05507 0.82571,-1.88079 1.88079,-1.88079l40.64331,0c1.05507,0 1.88079,0.87158 1.88079,1.88079s-0.82571,1.88079 -1.88079,1.88079z",
    className: "st10"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#868A91",
    d: "m645.7137,478.03411l-40.64331,0c-1.05507,0 -1.88079,-0.87158 -1.88079,-1.88079c0,-1.05507 0.82571,-1.88079 1.88079,-1.88079l40.64331,0c1.05507,0 1.88079,0.87158 1.88079,1.88079s-0.82571,1.88079 -1.88079,1.88079z",
    className: "st10"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#868A91",
    d: "m648.23671,502.14486l-40.64331,0c-1.05507,0 -1.88079,-0.87158 -1.88079,-1.88079c0,-1.05507 0.82571,-1.88079 1.88079,-1.88079l40.64331,0c1.05507,0 1.88079,0.87158 1.88079,1.88079s-0.82571,1.88079 -1.88079,1.88079z",
    className: "st10"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/Check.5ba653229ae9116fe7fe996032a28d18.svg";
export { ForwardRef as ReactComponent };